module.exports = __webpack_public_path__ + "static/media/groceryListIcon7.c60fec1f.svg";